/**
 * 移动端统计组件
 * @param {Object} params 扩展参数，参数内容如下
 *   @param {String} environment 客户端类型(默认根据环境自行判断)[h5|client]
 *   @param {String} hosturl h5发送地址设置（默认https://stadig.ifeng.com/appsta.js）
 *   @param {String} newsappsns h5发送地址主参数（默认datatype）
 *   @param {String} behavior 统计行为类型（page|action|pageinfo）必填
 *   @param {String} type 统计标识
 *   ......
 */
const Tools = {
    getUserkey() {
        if (this.getCookie('userkey')) {
            return this.getCookie('userkey');
        } else {
            const uid = this.createUserkey(15);
            const exp = new Date();

            exp.setTime(exp.getTime() + 30 * 24 * 60 * 60 * 1000);
            this.setCookie('userkey', uid, exp, '/');

            return uid;
        }
    },
    setCookie(name, value, expires, path, domain, secure) {
        if(typeof document !== 'object') {
            return false;
        }
        let cookieText = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

        if (expires instanceof Date) {
            cookieText = `${cookieText};expires=${expires.toGMTString()}`;
        }
        if (path) {
            cookieText = `${cookieText};path=${path}`;
        }
        if (domain) {
            cookieText = `${cookieText};domain${domain}`;
        }
        if (secure) {
            cookieText = `${cookieText};secure`;
        }
        document.cookie = cookieText;
    }, 
    getCookie(name) {
        if(typeof document !== 'object') {
            return '';
        }
        const cookieName = `${encodeURIComponent(name)}=`;
        const cookieStart = document.cookie.indexOf(cookieName);
        let cookieValue = null;

        if (cookieStart > -1) {
            let cookieEnd = document.cookie.indexOf(';', cookieStart);

            if (cookieEnd === -1) {
                cookieEnd = document.cookie.length;
            }
            cookieValue = document.cookie.substring(cookieStart + cookieName.length, cookieEnd);
            cookieValue = decodeURIComponent(cookieValue);
        }

        return cookieValue;
    },
    createUserkey(num) {
        const len = num || 32;
        const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        const charsLen = chars.length;
        let uid = '';

        for (let i = 0; i < len; i++) {
            uid += chars.charAt(Math.floor(Math.random() * charsLen));
        }

        return uid;
    },
}

// h5统计
const H5StatisticsObject = {
    HOSTURL: 'https://stadig.ifeng.com/appsta.js',
    DATATYPE: 'newsappsns',
    USERAGENT: typeof navigator === 'object' ? navigator.userAgent.toLocaleLowerCase() : '',
    FILTERKEY: ['hosturl','datatype', 'behavior', 'environment'],
    init(params = {}) {
        const behavior = params.behavior || '';
        const behaviorList = ['page','action']
        
        if (behaviorList.includes(behavior)) {
            const hostParams = this.getHostParams(params);
            const sessionParams = this.getSessionParams(params);
            const sendUrl = `${hostParams}&session=${sessionParams}`
            
            this.sendStatistics(sendUrl);
        }
    },
    sendStatistics(url) {
        if(typeof document !== 'object') {
            return false;
        }
        const script = document.createElement('script');

        script.src = url;
        script.async = 'async';
        document.body.appendChild(script);
    },
    getSessionParams(params){
        const sessionArray = [];

        if (Array.isArray(params) && params[0]){

            params.forEach(item => {
                const itemParamsArray = [];
                const behavior = item.behavior || '';

                for (const key in item) {
                    if(!this.FILTERKEY.includes(key)) {
                        itemParamsArray.push(`${key}=${encodeURIComponent(item[key])}`);
                    }
                }
                
                sessionArray.push(`${this.getTimeFormat()}#${behavior}#${itemParamsArray.join('$')}`);
            });
        } else {
            const behavior = params.behavior || '';
            const itemParamsArray = [];

            for (const key in params) {
                if(!this.FILTERKEY.includes(key)) {
                    itemParamsArray.push(`${key}=${encodeURIComponent(params[key])}`);
                }
            }
            
            sessionArray.push(`${this.getTimeFormat()}#${behavior}#${itemParamsArray.join('$')}`);
        }

        return encodeURIComponent(sessionArray.join('@'));
    },
    getHostParams(params) {
        const paramsValue = (Array.isArray(params) && params[0]) ? params[0] : params;
        const hosturl = paramsValue.hosturl || this.HOSTURL;
        const datatype = paramsValue.datatype || this.DATATYPE;

        return `${hosturl}?datatype=${datatype}&mos=${this.getSystem()}&userkey=${Tools.getUserkey()}&ua=${encodeURIComponent(this.USERAGENT)}&share=${this.getSourceName()}`;
    },
    getSystem() {
        const USERAGENT = this.USERAGENT;

        if (USERAGENT.match(/iphone|ipod/gi) || USERAGENT.match(/ipad/gi)) {
            return 'iphone';
        } else if (USERAGENT.match(/android/gi)) {
            return 'android';
        } else if (USERAGENT.match(/arkweb/gi)) {
            return 'hmos';
        } else {
            return 'windows';
        }
    },
    getSourceName() {
        const USERAGENT = this.USERAGENT;

        if(USERAGENT.match(/wxwork/gi)) {
            return 'qywx';
        } else if (USERAGENT.match(/MicroMessenger/gi)) {
            return 'wx';
        } else if (USERAGENT.match(/QQ\//)) {
            return 'qq';
        } else if (USERAGENT.match(/WeiBo/i)) {
            return 'weibo';
        } else {
            return 'unknown';
        }
    },
    singleNumberAddZero(num) {
        return num > 9 ? num : `0${num}`;
    }, 
    getTimeFormat() {
        const now = new Date();
        const year = now.getFullYear();
        const month = this.singleNumberAddZero(now.getMonth() + 1);
        const day = this.singleNumberAddZero(now.getDate());
        const hour = this.singleNumberAddZero(now.getHours());
        const min = this.singleNumberAddZero(now.getMinutes());
        const sec = this.singleNumberAddZero(now.getSeconds());
        // 输出格式为2016-05-27+09:04:36
        const timeFormat = `${year}-${month}-${day}+${hour}:${min}:${sec}`;

        return now ? timeFormat : '';
    }
}

// 客户端统计
const ClientStatisticsObject = {
    FILTERKEY: ['hosturl','datatype', 'behavior', 'environment'],
    init(params = {}) {
        if(typeof window !== 'object') {
            return false;
        }
        const pageInfo = {
            rnum: this.getQuery(window.location.href, 'rnum') || window?.grounds?.getPageInfo?.()?.getRnum?.() || '',
            ref: this.getQuery(window.location.href, 'ref') || window?.grounds?.getPageInfo?.()?.getRef?.() || '',
            showtype: this.getQuery(window.location.href, 'showtype') || window?.grounds?.getPageInfo?.()?.getShowtype?.() || '',
            tag: this.getQuery(window.location.href, 'tag') || window?.grounds?.getPageInfo?.()?.getTag?.() || ''
        }

        if (Array.isArray(params)){
            params.forEach((item) => {
                if (item.behavior === 'page' && window.grounds && window.grounds.pageStat) {
                    const allParams = {
                        ...pageInfo,
                        ...item,
                    };
                    window.grounds.pageStat(this.formateParams(allParams));
                    this.sendCustomStatistics('page', allParams);
                }

                if(item.behavior === 'action' && window.grounds && window.grounds.actionStat) {
                    window.grounds.actionStat(this.formateParams(item));
                    this.sendCustomStatistics('action', item);
                }
                if(item.behavior === 'pageinfo' && window.grounds && window.grounds.expose) {
                    window.grounds.expose(this.formateParams(item));
                    this.sendCustomStatistics('expose', item);
                }
                if(item.behavior === 'commentinfo' && window.grounds && window.grounds.commentStat) {
                    window.grounds.commentStat(this.formateParams(item));
                    this.sendCustomStatistics('comment', item);
                }
            });
        } else {
            if (params.behavior === 'page' && window.grounds && window.grounds.pageStat) {
                const allParams = {
                    ...pageInfo,
                    ...params,
                };

                window.grounds.pageStat(this.formateParams(allParams));
                this.sendCustomStatistics('page', allParams);
            }

            if(params.behavior === 'action' && window.grounds && window.grounds.actionStat) {
                window.grounds.actionStat(this.formateParams(params));
                this.sendCustomStatistics('action', params);
            }
            if(params.behavior === 'pageinfo' && window.grounds && window.grounds.expose) {
                window.grounds.expose(this.formateParams(params));
                this.sendCustomStatistics('expose', params);
            }
            if(params.behavior === 'commentinfo' && window.grounds && window.grounds.commentStat) {
                window.grounds.commentStat(this.formateParams(params));
                this.sendCustomStatistics('comment', params);
            }
        }
    },
    formateParams(params) {
        const newParams = {};

        for (const key in params) {
            if(!this.FILTERKEY.includes(key)) {
                newParams[key] = encodeURIComponent(params[key]);
            }
        }

        return JSON.stringify(newParams);
    },
    newFunction(params) {
        console.log(params);
    },
    getQuery(url, key) {
        let value = '';
    
        try {
            const urlObj = new URL(url);
            const { searchParams } = urlObj;
    
            if (searchParams.has(key)) {
                value = searchParams.get(key);
            }
        } catch (e) {
            return '';
        }
    
        return value;
    },
    sendCustomStatistics(type, params) {
        if (typeof window !== 'object') {
            return false;
        }
        const clientPageInfo = {
            rnum: window?.grounds?.getPageInfo?.()?.getRnum?.() || '',
            ref: window?.grounds?.getPageInfo?.()?.getRef?.() || '',
            showtype: window?.grounds?.getPageInfo?.()?.getShowtype?.() || '',
            tag: window?.grounds?.getPageInfo?.()?.getTag?.() || '',
            pagetag: window?.grounds?.getPageInfo?.()?.getPagetag?.() || '',
        };
        /* eslint-disable-next-line */
        const NODEENV = typeof NODE_ENV === 'undefined' ? window.NODE_ENV : NODE_ENV;
        const isUrlDev = window.location.href.includes('devSta=1');
    
        if (NODEENV === 'development' || NODEENV === 'staging' || isUrlDev) {
            const script = document.createElement('script');
    
            script.src = `http://fe.custom.ifeng.com/appsta.js?${type}=${JSON.stringify(params)}&clientPageInfo=${JSON.stringify(clientPageInfo)}`;
            script.async = 'async';
            document.body.appendChild(script);
        } else {
            console.log(`统计上报 ${type}=${JSON.stringify(params)} clientPageInfo=${JSON.stringify(clientPageInfo)}`);
        }
    }
}

let isVolcengineConfig= false;
const volcengineStatisticsObject = {
    init(params = {}) {
        if(typeof window !== 'object') {
            return false;
        }
        const behavior = params.behavior || '';
        const behaviorList = ['action', 'page'];
        const type = params.type || '';

        if(!isVolcengineConfig && window.collectEvent) {
            window.collectEvent('config', {
                user_unique_id: Tools.getUserkey()  
            });
            isVolcengineConfig = true;
        }
        
        // action 统计
        if (
            window.collectEvent &&
            behaviorList.includes(behavior) &&
            type
        ) {
            const filterList = ['type', 'behavior', 'hosturl', 'newsappsns', 'environment']
            const filterValue = Object.keys(params)
                                .filter(key => (!filterList.includes(key)))
                                .reduce((obj, key) => {
                                    obj[key] = params[key];

                                    return obj;
                                }, {});
                                

            window.collectEvent(type, {
                ...filterValue
            });
        }
    },
}



// 火山统计
const volcengineStatistics = params => {
    volcengineStatisticsObject.init(params);
};

// h5环境
const h5Statistics = params => {
    H5StatisticsObject.init(params);
};
// 新闻客户端环境环境
const clientStatistics = params => {
    ClientStatisticsObject.init(params);
};

// 环境判断
const pageStatistics = (params) => {
    if(typeof window !== 'object') {
        return false;
    }
    const environmentParams = params.environment || (params[0] && params[0].environment) || ''
    const environment = environmentParams || (window.grounds ? 'client' : 'h5');

    if(environment === 'client') {
        clientStatistics(params);
    } else {
        h5Statistics(params);
    } 
}

// 火山和凤凰双发统计
const volcengineAndH5Statistics = (params) => {
    if(typeof window !== 'object') {
        return false;
    }
    const environment = params.environment || (params[0] && params[0].environment) || '';

    if(environment === 'volcengine' && window.collectEvent) {
        volcengineStatistics(params);
    } else if (environment == 'h5' || environment == 'client'){
        pageStatistics(params);
    } else {
        volcengineStatistics(params);
        pageStatistics(params);
    }
}



export { pageStatistics, h5Statistics, clientStatistics, volcengineAndH5Statistics, volcengineStatistics };
